import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { ThreeBounce } from 'better-react-spinkit';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import { FlexColContainer } from 'components/StyledComp';

const propTypes = {
  type: PropTypes.string,
  size: PropTypes.number,
  delay: PropTypes.number,
};

const defaultProps = {
  type: 'ThreeBounce',
  size: 32,
  delay: 500,
};

@autobind
class LoadingIndicator extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      delaying: true,
    };

    this.delayTimer = setTimeout(() => {
      this.setState({
        delaying: false,
      });
    }, this.props.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.delayTimer);
  }

  render() {
    const { type, size, theme } = this.props;
    const { delaying } = this.state;

    return (
      <FlexColContainer
        width="wrap_content"
        height="wrap_content"
      >
        {!delaying && type === 'ThreeBounce' &&
          <ThreeBounce
            color={theme.colors.primaryLight}
            size={size}
          />
        }
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
LoadingIndicator.propTypes = propTypes;
LoadingIndicator.defaultProps = defaultProps;

export default withTheme(LoadingIndicator);
